import * as React from "react"
import {ErrorMessage} from "@hookform/error-message";
import {useFormContext} from "react-hook-form";

interface IProps {
    fieldName: string
}

export const ValidationMessage = ({fieldName}: IProps) => {
    const {formState: {errors}} = useFormContext();

    return (
        <ErrorMessage  
            errors={errors}
            name={fieldName}
            render={({message}) => (<>{message && <span className="text-danger form-error-msg">{message}</span>}</>)}
        />
    )
}